module.exports = __webpack_public_path__ + "img/histogram_example.9fa32fb6.png";